module.exports = __webpack_public_path__ + "static/img/know_how_2.a04d3aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/know_how_2.png
// module id = Xa3Y
// module chunks = 0